export const TARGET_SAMPLE_RATE = 24000;

export function concatBytes(a: Uint8Array, b: Uint8Array): Uint8Array {
  if (a.length === 0) return b;
  if (b.length === 0) return a;
  const out = new Uint8Array(a.length + b.length);
  out.set(a, 0);
  out.set(b, a.length);
  return out;
}

export function pcm16leToFloat32(pcmData: Uint8Array): Float32Array {
  const samples = new Float32Array(Math.floor(pcmData.length / 2));
  for (let i = 0; i < samples.length; i++) {
    const int16 = (pcmData[i * 2 + 1] << 8) | pcmData[i * 2];
    const signed = int16 > 0x7fff ? int16 - 0x10000 : int16;
    samples[i] = signed / (signed < 0 ? 0x8000 : 0x7fff);
  }
  return samples;
}

export function float32ToPcm16Base64(float32Array: Float32Array): string {
  const int16Array = new Int16Array(float32Array.length);
  for (let i = 0; i < float32Array.length; i++) {
    const s = Math.max(-1, Math.min(1, float32Array[i]));
    int16Array[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
  }

  const uint8Array = new Uint8Array(int16Array.buffer);
  let binary = "";
  const chunkSize = 0x8000;
  for (let i = 0; i < uint8Array.length; i += chunkSize) {
    const chunk = uint8Array.subarray(i, Math.min(i + chunkSize, uint8Array.length));
    binary += String.fromCharCode.apply(null, Array.from(chunk));
  }
  return btoa(binary);
}

export function resampleFloat32(
  input: Float32Array,
  fromRate: number,
  toRate: number,
): Float32Array {
  if (!input.length || fromRate === toRate) {
    return input;
  }

  const ratio = fromRate / toRate;
  const outLength = Math.max(1, Math.round(input.length / ratio));
  const output = new Float32Array(outLength);

  for (let i = 0; i < outLength; i++) {
    const srcIndex = i * ratio;
    const i0 = Math.floor(srcIndex);
    const frac = srcIndex - i0;
    const s0 = input[i0] ?? 0;
    const s1 = input[Math.min(i0 + 1, input.length - 1)] ?? s0;
    output[i] = s0 + (s1 - s0) * frac;
  }

  return output;
}
